// TODO: Make starting values manageable for employees and participation

class RoiAnalysis {
  constructor(element) {
    this.calculator = element;

    this.elegibleMembers = element.querySelector('[data-element="elegibleMembers"]');
    this.diagnosedMembers = element.querySelector('[data-element="diagnosedMembers"]');
    this.annualCost = element.querySelector('[data-element="annualCost"]');
    this.totalSavings = element.querySelector('[data-element="totalSavings"]');

    // Array of fields to be pre-filled
    this.allFieldsNames = [
      'elegibleMembers',
      'diagnosedMembers',
      'annualCost',
      'totalSavings',
    ];

    this.digitsAndDots = /[^\d.]/g;

    this.formats = {
      integer: {
        style: 'decimal',
        maximumFractionDigits: 0,
      },
      currency: {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
      },
    };

    this.formatOptions = {
      elegibleMembers: this.formats.integer,
      diagnosedMembers: this.formats.integer,
      annualCost: this.formats.currency,
      totalSavings: this.formats.currency,
    };

    // Add elements to this using the name
    this.elegibleMembers.addEventListener('input', this.performCalculations.bind(this));
    this.elegibleMembers.addEventListener('focusin', this.handleFocusIn.bind(this));
    this.elegibleMembers.addEventListener('focusout', this.handleFocusOut.bind(this));

    // Static initialValues
    this.initialValues = window.initialValues || {
      elegibleMembers: 95,
    };

    this.factors = window.factors || {
      diagnosedMembers: 0,
      annualCost: 0,
      totalSavings: 0,
    };

    // Keep current inputs and outpus as state to perform further calculations
    this.state = {
      elegibleMembers: 0,
      diagnosedMembers: 0,
      annualCost: 0,
      totalSavings: 0,
    };

    // Move initial static value to state
    this.state.elegibleMembers = parseFloat(this.initialValues.elegibleMembers);

    // Fill all empty fields
    this.fillInputs();

    // Trigger calculations on load
    this.performCalculations();
  }

  /**
   * Fill in all inputs with initial values
   */
  fillInputs() {
    // Loop over all keys that have initital values
    Object.keys(this.initialValues).forEach((element) => {
      // Set the value of the element to its initial value
      this[element].value = parseFloat(
        this.initialValues[element]).toLocaleString(
        'en-US',
        this.formatOptions[element]
      );
      // Set the state of the element according to the current value
      this.state[element] = parseFloat(
        this[element].value.replace(this.digitsAndDots, '')
      );
    });
  }

  /**
   * Multiply and show elegible members by the element factor
   *
   * @param {String} element Element identifier to multiply
   */
  multiplyElegibleByFactor(element) {
    // Set state to result of multiplying
    this.state[element] = this.state.elegibleMembers * this.factors[element];
    // Set element value to state value
    this[element].value = this.state[element].toLocaleString(
      'en-US',
      this.formatOptions[element]
    );
  }

  /**
   * Perform all calculations
   *
   * @param {Object} e Event, if triggered by an event listener.
   */
  performCalculations(e) {
    // Check if if the calculations are triggered by an event
    if (e && e.target) {
      // If so, check if the value is a number and update the value on the state from the updated input (event target), or set it to 0 if it's not a number
      if (e.target.value) {
        this.state[e.target.dataset.element] = parseFloat(
          e.target.value.replace(this.digitsAndDots, '')
        );
      } else {
        this.state[e.target.dataset.element] = 0;
      }
    }

    // Multiply each element that has a factor
    Object.keys(this.factors).forEach((element) => this.multiplyElegibleByFactor(element));
  }

  /**
   * Handler for focusing in of input
   *
   * @param {Object} e Focus out event
   */
  handleFocusIn(e) {
    e.target.value = e.target.value.replace(this.digitsAndDots, '');
  }

  /**
   * Handler for focusing out of input
   *
   * @param {Object} e Focus out event
   */
  handleFocusOut(e) {
    // Check if there's an event, a target, and an id
    if (e && e.target) {
      // Set constants
      const {element} = e.target.dataset;

      // Set formatted input value
      if (isNaN(this.state[element])) {
        e.target.value = parseFloat(this.initialValues[element]).toLocaleString(
          'en-US',
          this.formatOptions.integer
        );
      } else {
        e.target.value = this.state[element].toLocaleString('en-US', this.formatOptions.integer);
      }
    }
    this.performCalculations(e);
  }
}

const roiAnalysis = {
  init() {
    const roiAnalysisContainers = document.querySelectorAll('[data-module="roi-calculator"]');

    if (roiAnalysisContainers) {
      roiAnalysisContainers.forEach((roiAnalisisContainer) => new RoiAnalysis(roiAnalisisContainer));
    }
  },
};

export default roiAnalysis;
